export const apiUrl = 'https://patternlanguageforgamedesign.com/PatternLibrary/';
//export const apiUrl = 'http://localhost/PatternLibrary/';

export const clearCacheUrl = 'https://patternlanguageforgamedesign.com/PatternLibraryApp/meta.json';
//export const clearCacheUrl = 'http://localhost:3000/PatternLibraryApp/meta.json';

export default apiUrl;